module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "posts post-detail"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.forum.forum_topic))])]), _vm._v(" "), _c('div', {
    staticClass: "post-meta clearfix"
  }, [_c('div', {
    staticClass: "post-meta-author"
  }, [_vm._v("By "), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v(_vm._s(_vm.forum.forum_created_by))])]), _vm._v(" "), _c('div', {
    staticClass: "post-meta-date"
  }, [_vm._v(_vm._s(_vm.forum.forum_reg_date))]), _vm._v(" "), _c('div', {
    staticClass: "post-meta-categories"
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.forum.forum_category))])]), _vm._v(" "), _c('div', {
    staticClass: "post-meta-comments"
  }, [_c('i', {
    staticClass: "fa fa-comments"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.forum.forum_comments_count) + " comments")])]), _vm._v(" "), (_vm.forum_can_edit) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#edit-forum"
    },
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("Edit Forum "), _c('i', {
    staticClass: "fa fa-edit"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "post-content"
  }, [_c('p', {
    staticClass: "drop-cap"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.setForumDsc(_vm.forum.forum_description))
    }
  }), _vm._v(" "), (_vm.forum.forum_attachment) ? _c('span', {
    staticStyle: {
      "padding-top": "1em"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "fc-img",
    attrs: {
      "src": _vm.img_url + _vm.forum.forum_attachment
    }
  })]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('p', [_vm._v("Share On")]), _vm._v(" "), _c('ul', {
    staticClass: "social-links nav nav-pills"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": 'https://twitter.com/share?url=' + _vm.forum.forum_url + '&text=' + _vm.forum.forum_topic + '&hashtags=cityneeds',
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": 'http://www.facebook.com/sharer.php?u=' + _vm.forum.forum_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "linky",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v("Copy Link")])])])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reviews"
    }
  }, [_vm._v(_vm._s(_vm.forum.forum_comments.length) + " Comment(s)")]), _vm._v(" "), _c('div', {
    staticClass: "comments"
  }, [_vm._l((_vm.forum.forum_comments), function(comment) {
    return [_c('div', {
      staticClass: "comment"
    }, [_c('div', {
      staticStyle: {
        "background": "#fff",
        "padding": "5px"
      }
    }, [_c('div', {
      staticClass: "comment-header"
    }, [_c('div', {
      staticClass: "comment-image"
    }, [_c('img', {
      staticClass: "img-circle",
      attrs: {
        "src": _vm.img_url + comment.forum_comment_user_image,
        "alt": "",
        "width": "35",
        "height": "35"
      }
    })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(comment.forum_comment_user))]), _vm._v(" "), _c('span', {
      staticClass: "separator"
    }, [_vm._v("•")]), _vm._v(" "), _c('span', {
      staticClass: "comment-date"
    }, [_vm._v(_vm._s(comment.forum_comment_date))])]), _vm._v(" "), _c('div', {
      staticClass: "comment-content-wrapper"
    }, [_c('div', {
      staticClass: "comment-content",
      staticStyle: {
        "padding-left": "15px"
      }
    }, [_c('p', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.setForumDsc(comment.forum_comment_comment))
      }
    }), _vm._v(" "), (comment.forum_comment_attachment) ? _c('span', {
      staticStyle: {
        "margin-top": "1.4em"
      }
    }, [_c('img', {
      staticClass: "fc-img",
      attrs: {
        "src": _vm.img_url + comment.forum_comment_attachment
      }
    })]) : _vm._e()]), _vm._v(" "), (_vm.can_edit_comment(comment.forum_comment_post_ref_no)) ? _c('div', {
      staticClass: "pull-right"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#edit-comment"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('forum_comment', comment)
        }
      }
    }, [_vm._v("Edit Comment"), _c('i', {
      staticClass: "fa fa-edit"
    })])]) : _vm._e()])])])])]
  })], 2), _vm._v(" "), _c('h2', [_vm._v("Join The Discussion")]), _vm._v(" "), _c('form', {
    staticClass: "background-white p20 add-comment"
  }, [(!_vm.loggedIn) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-xl",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setReg
    }
  }, [_vm._v("\r\n                                    Log In / Create your cityneeds account\r\n                                ")])])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("What do you think?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment.forum_comment_comment),
      expression: "comment.forum_comment_comment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "id": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.comment.forum_comment_comment)
    },
    on: {
      "change": _vm.trackevent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment.forum_comment_comment = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" Add a Photo to your post?")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addComment
    }
  }, [_c('i', {
    staticClass: "fa fa-comments"
  }), _vm._v("Post\r\n                                ")])])])])])])])])]), _vm._v(" "), _c('main-footer'), _vm._v(" "), _c('create-thread'), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "edit-forum",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "0px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Discussion Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forum.forum_topic),
      expression: "forum.forum_topic"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Discussion Title"
    },
    domProps: {
      "value": (_vm.forum.forum_topic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.forum.forum_topic = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Category "), _c('b', [_vm._v(_vm._s(_vm.forum.forum_category))])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forum.forum_category_id),
      expression: "forum.forum_category_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.forum.forum_category_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("CNpro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Business")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Community")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Short Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forum.forum_description),
      expression: "forum.forum_description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "placeholder": "What would you want to discuss?"
    },
    domProps: {
      "value": (_vm.forum.forum_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.forum.forum_description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.forum.forum_attachment) ? _c('span', [_c('img', {
    staticClass: "fc-img",
    attrs: {
      "src": _vm.img_url + _vm.forum.forum_attachment
    }
  }), _vm._v(" "), _c('label', [_vm._v(" Change Photo?")])]) : _c('span', [_c('label', [_vm._v(" Add a Photo?")])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.editForum
    }
  }, [_vm._v("Save")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "edit-comment",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "0px"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Edit Comment")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment.forum_comment_comment),
      expression: "comment.forum_comment_comment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.comment.forum_comment_comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment.forum_comment_comment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.comment.forum_comment_attachment) ? _c('span', [_c('img', {
    staticClass: "fc-img",
    attrs: {
      "src": _vm.img_url + _vm.comment.forum_comment_attachment
    }
  }), _vm._v(" "), _c('label', [_vm._v(" Change Photo?")])]) : _c('span', [_c('label', [_vm._v(" Add a Photo?")])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.editComment(_vm.comment)
      }
    }
  }, [_vm._v("Save")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "guest-poll",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "col-sm-8 col-md-offset-2 modal-content",
    staticStyle: {
      "top": "10em",
      "border-radius": "0px",
      "padding": "0"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("If you would like to partake in future CNforum discussions, or even initiate a CNforum discussion, register now!\r\n            ")]), _vm._v(" "), _c('center', [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "/register",
      "type": "button"
    }
  }, [_vm._v("Sign Up")])])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "href": "/forums"
    }
  }, [_vm._v("Back to Forum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "color": "#9c0909",
      "font-size": "18px",
      "line-height": "1.6"
    }
  }, [_vm._v("Oops! You will have to log in to join the discussion.\r\n                                    "), _c('br'), _vm._v("Don't have a Cityneeds account?"), _c('br'), _vm._v(" Create one; It won't take you more than a minute.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("Edit This Forum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "background-image": "url('https://cityneeds.ng/cnpro.jpg')",
      "height": "8em"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63b31f8d"}!./src/components/Forum/template.html
// module id = 297
// module chunks = 0